import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types/api';

export interface SitterFavorite {
  id?: number;
  sitterId: number;
  parentId: number;
}

const URL = '/v2/sitter-favorites';

class SitterFavoritesService {
  static create(
    data: Omit<SitterFavorite, 'id'>,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<SitterFavorite>> {
    return axios.post(URL, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig): Promise<unknown> {
    return axios.delete(`${URL}/${id}`, config);
  }
}

export { SitterFavoritesService };
